module.exports = __webpack_public_path__ + "a1195c4c02d4ae5dfdebe928292c4be1.svg";